var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!!this.message)?_c('div',[_vm._v(_vm._s(this.message))]):_c('div',[_vm._v(_vm._s(this.messageAction))])}
var staticRenderFns = []

export { render, staticRenderFns }